import { Component, OnInit,OnDestroy, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { DialogResultService } from './../services/dialog-result.service';
// import { ItemDataService } from './../services/item-data.service';
// import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']

})
export class DialogComponent implements OnInit {
  @Input() closable = true;
  @Input() visible: boolean;
  @Input() itemName : string;
  @Input() sectionName: string;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() dialogAnswer: EventEmitter<string> = new EventEmitter<string>();
  //subsciption: Subscription;
  myItem;
  
  constructor(private dialogResultService:DialogResultService) { }

  async ngOnInit() {
    
    // let myMessage = await this.itemDataService.getMessage();
    // this.myItem = JSON.parse(myMessage);
    // this.subsciption = this.itemDataService.currentMessage.subscribe(message=>{
    //   this.myItem=JSON.parse(message);
    //   console.log(message);
    // });
  }
  choice(myChoice){
    
    //this.dialogResultService.changeMessage(myChoice);
    this.dialogAnswer.emit(myChoice);
    this.close();
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
  ngOnDestroy(){
    //this.subsciption.unsubscribe();
  }

}
